import React from "react";

const statusCardColor = (name = "") => {
  if (/açık|open/i.test(name))              return "#dc3545";
  if (/kapalı|closed|tamamlan/i.test(name)) return "#198754";
  if (/onay|süreç|review/i.test(name))      return "#fd7e14";
  if (/red|reject/i.test(name))             return "#6c757d";
  return "#0d6efd";
};

const StatCard = ({ label, value, color }) => (
  <div
    className="rounded text-white text-center py-3 px-4 d-flex flex-column justify-content-center"
    style={{ backgroundColor: color, minWidth: 130 }}
  >
    <div className="fw-bold" style={{ fontSize: 40, lineHeight: 1.1 }}>{value}</div>
    <div style={{ fontSize: 13, marginTop: 4 }}>{label}</div>
  </div>
);

const OverallCard = ({ label, value }) => (
  <div
    className="rounded text-white text-center py-3 px-4 mb-2"
    style={{ backgroundColor: "#1a3a5c", minWidth: 200 }}
  >
    <div className="fw-bold" style={{ fontSize: 40, lineHeight: 1.1 }}>{value ?? "—"}</div>
    <div style={{ fontSize: 13, marginTop: 4 }}>{label}</div>
  </div>
);

const DefaultReportOverview = ({ data, translate }) => {
  const t = (key) => translate(`project_settings.reports.default_report.${key}`);
  const { overall, templates } = data;

  return (
    <div className="d-flex gap-4 align-items-start">
      <div className="flex-grow-1">
        {templates.map((template) => (
          <div key={template.id} className="mb-4">
            <div className="fw-bold text-uppercase mb-2" style={{ fontSize: 13, letterSpacing: 1 }}>
              {template.name}
            </div>
            <div className="d-flex flex-wrap gap-2">
              <StatCard label={t("total")} value={template.stats.total} color="#0d6efd" />
              {template.stats.by_status.map((s) => (
                <StatCard
                  key={s.status_id}
                  label={s.status_name}
                  value={s.count}
                  color={statusCardColor(s.status_name)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex flex-column" style={{ minWidth: 170 }}>
        <div className="text-muted small fw-semibold mb-2 text-center">{t("new_forms")}</div>
        <OverallCard label={t("last_7_days")}  value={overall.last_7_days} />
        <OverallCard label={t("last_30_days")} value={overall.last_30_days} />
        <OverallCard label={t("this_year")}    value={overall.this_year} />
        <OverallCard label={t("avg_response")} value={overall.avg_response_days} />
      </div>
    </div>
  );
};

export default DefaultReportOverview;
